<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { initThemeColor, changeThemeColor } from '@/plugins/themeColorClient'
import { mapState } from 'vuex'
export default {
    name: 'App',
    computed: {
        ...mapState(['configData']),
    },
    methods: {
        // setTheme(color) {
        // 	console.log({color});
        // 	initThemeColor()
        // 	changeThemeColor(color)
        // }
    },
    watch: {
        $route(to, from) {
            let href = window.location.href;

            if (href.includes('damaijia168.cn')) {
                this.$router.replace({
                    path: '/blog-home',
                })
            } else if (to.path === '/blog-home') { // 不是 damaijia168.cn 且跳转到 /boog-home 则跳转回 /
                this.$router.replace({
                    path: '/',
                })
            }
        },
    },
    async mounted() {
        // if (+this.configData.id === 1) {
        //     this.$router.replace({
        //         path: '/blog-home',
        //     })
        // }
        // if (Object.keys(this.configData).length == 0) {
        //     await this.$store.dispatch('getConfig')
        //     if (this.configData.color && this.configData.id != 1) {
        // 		this.setTheme(this.configData.color)
        // 		document.title = this.configData.name
        //     } else {
        // 		setTimeout(() => {
        // 			if (this.configData.color && this.configData.id != 1) {
        // 				this.setTheme(this.configData.color)
        // 				document.title = this.configData.name
        // 			}
        // 		}, 500);
        // 	}
        // }
    },
}
</script>

<style lang="scss">
#app {
    min-width: 1260px;

    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
